export default __webpack_public_path__ + "/assets/mega_01.jpg";